// extracted by mini-css-extract-plugin
module.exports = {"block":"userCountries_block__J5ohs","title":"userCountries_title__gOXyI"};